import { client } from './client'

export async function getPopup() {
  return client.fetch(`
    *[_type == "popup"][0] {
      attivo,
      etichetta,
      titolo,
      sottotitolo,
      "immagine": immagine.asset->url,
      linkHref,
      linkLabel,
    }
  `)
}

export async function getEventi() {
  return client.fetch(`
    *[_type == "evento"] | order(data desc) {
      "id": _id,
      "slug": slug.current,
      titolo,
      data,
      dataFine,
      luogo,
      citta,
      categoria,
      descrizione,
      descrizioneCompleta,
      "immagine": immagine.asset->url,
      "foto": foto[].asset->url,
      linkEsterno,
      featured,
    }
  `)
}

export async function getEventoBySlug(slug: string) {
  return client.fetch(`
    *[_type == "evento" && slug.current == $slug][0] {
      "id": _id,
      "slug": slug.current,
      titolo,
      data,
      dataFine,
      luogo,
      citta,
      categoria,
      descrizione,
      descrizioneCompleta,
      "immagine": immagine.asset->url,
      "foto": foto[].asset->url,
      linkEsterno,
      featured,
    }
  `, { slug })
}

export async function getEventiFeatured() {
  return client.fetch(`
    *[_type == "evento" && featured == true] | order(data desc) {
      "id": _id,
      "slug": slug.current,
      titolo,
      data,
      dataFine,
      luogo,
      citta,
      categoria,
      descrizione,
      "immagine": immagine.asset->url,
      featured,
    }
  `)
}